import { createQueryBuilderV4 } from "@odata2ts/odata-query-builder";
import {
  qNonConformanceTransition,
  QNonConformanceTransition,
} from "../../odata/appu4dm/QAppU4DM";
import { useQuery } from "@tanstack/react-query";
import { ncKeys } from "./nc-keys";
import { odataFetch } from "../../lib/odata-fetch";
import { fetchConfiguration } from "../configuration/use-configuration";
import { NonConformanceTransition } from "../../odata/appu4dm/AppU4DMModel";

export function useNCTransitions(fromStatusNId?: string) {
  const { data, ...query } = useQuery({
    queryKey: ncKeys.getTransitions(),
    queryFn: ({ meta }) => fetchNCTransitions(fromStatusNId!, meta!.token!),
    enabled: ({ meta }) => !!meta?.token && !!fromStatusNId,
  });

  return {
    transitions: data?.value,
    ...query,
  };
}

async function fetchNCTransitions(fromStatusNId: string, token: string) {
  const config = await fetchConfiguration(
    "nonConformanceLifeCycleforMaterialItem",
    token
  );

  const builder = createQueryBuilderV4(
    "NonConformanceTransition",
    new QNonConformanceTransition()
  )
    .filter(
      qNonConformanceTransition.FromStatus.getEntity(true)
        .NId.eq(fromStatusNId)
        .or(qNonConformanceTransition.NId.eq(fromStatusNId)),
      qNonConformanceTransition.Lifecycle.eq(config?.value[0].Val ?? null)
    )
    .expanding("ToStatus", (b) => b.select("Name"));

  return odataFetch<NonConformanceTransition>({ builder, token });
}
